
  import * as ipxRuntime$NYqBuh3LsnPzGhRC6zV8j5S3lwRvFG4_4523GKSxjCNI8 from '/builds/escapadarural/rurality-nuxt/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "dev.media.er2.co",
    "media.er2.co",
    "static.er2.co",
    "loremflickr.com",
    "s3-static.escapadarural.com",
    "www.escapadarural.com",
    "webp.er2.co"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$NYqBuh3LsnPzGhRC6zV8j5S3lwRvFG4_4523GKSxjCNI8, defaults: {} }
    }
  }
